export default __webpack_public_path__ + "static/me-c0d8d2ef2ff171081089daca77e13ce4.jpg";